export const state = {
    dev: {
        info: false
    }
};

export default state;
